import Vue from 'vue'
// import _ from 'lodash'

/* eslint-disable */
export default {
  namespaced: true,
  state: {
    loading: false,
    error: false,
    beach: {}
  },
  actions: {
    getBeach ({rootState, commit, dispatch}, data) {
      console.log('getBeach: ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/api/beach/getbeach', { beachid: data },
          ).then(response => {
            // console.log(response)
            // dispatch('getGuests')
            // dispatch('getPasses')
            commit('SET_GUEST', true, {root: true})
            commit('SET_BEACH', response.data.hotel)
            commit('hotels/SET_ACTIVEHOTEL', response.data.hotel, {root: true})
            commit('ombrelloni/LOAD_OMBRELLONI', response.data.ombrelloni, {root: true})
            commit('guests/LOAD_GUESTS', response.data.guests, {root: true})
            commit('SET_LOADING', false)
            resolve('ok')
          }, error => {
            console.log(error)
            reject(error)
            commit('SET_LOADING', false)
          })
        })
    }
  },
  mutations: {
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_BEACH (state, data) {
      state.beach = data
    }
  },
  getters: {}
}
